import {
    CAlert,
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow
} from '@coreui/react';
import { memo, Suspense } from 'react';
import { Await, defer, useLoaderData } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import { getDataFromStorage, transformedData } from '../../utils/helpers';
import { ENV } from '../../utils/constants';
import NoData from '../../components/NoData';
import AnnouncementTable from '../../components/AnnouncementTable';

const Announcements = () => {
    const { announcements } = useLoaderData();

    return (
        <Suspense fallback={<Spinner asOverlay />}>
            {announcements && announcements.length > 0 ? (
                <CRow>
                    <CCol xl={12} lg={12}>
                        <CCard>
                            <CCardHeader>Announcements</CCardHeader>
                            <CCardBody>
                                <Await
                                    resolve={announcements}
                                    errorElement={
                                        <CAlert color='danger'>
                                            An error occurred!
                                        </CAlert>
                                    }
                                    children={el => (
                                        <AnnouncementTable announcements={el} />
                                    )}
                                />
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            ) : (
                <NoData title='Announcements' />
            )}
        </Suspense>
    );
};

export const loader = async () => {
    return defer({ announcements: await getAnnouncements() });
};

export const getAnnouncements = async () => {
    const { token } = getDataFromStorage();
    const res = await fetch(`${ENV.adminBaseUrl}/announcements`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!res.ok) throw res;
    const resData = await res.json();
    return transformedData(resData.data);
};

export default memo(Announcements);
